import {
  STATE_TRANSITION_ATTRIBUTE_KEY,
  STATE_TRANSITION_BASE_ATTRIBUTE_KEY,
} from 'dashboard/constants/automation';

const setArrayValues = item => {
  return item.values[0]?.id ? item.values.map(val => val.id) : item.values;
};

const generateValues = item => {
  // Handle state transition values: {from: [{id, name}, ...], to: [{id, name}, ...]}
  // Transform to {from: ['pending'], to: ['open']} for backend
  if (
    item.filter_operator === 'attribute_changed' &&
    item.values &&
    typeof item.values === 'object' &&
    !Array.isArray(item.values) &&
    ('from' in item.values || 'to' in item.values)
  ) {
    return {
      from: Array.isArray(item.values.from)
        ? item.values.from.map(v => v?.id || v)
        : [],
      to: Array.isArray(item.values.to)
        ? item.values.to.map(v => v?.id || v)
        : [],
    };
  }
  if (Array.isArray(item.values)) {
    return setArrayValues(item);
  }
  if (typeof item.values === 'object') {
    return [item.values.id];
  }
  if (!item.values) {
    return [];
  }
  return [item.values];
};

const generatePayload = data => {
  // Make a copy of data to avoid vue data reactivity issues
  const filters = JSON.parse(JSON.stringify(data));
  let payload = filters.map(item => {
    // Map status_change back to status for backend compatibility
    if (item.attribute_key === STATE_TRANSITION_ATTRIBUTE_KEY) {
      item.attribute_key = STATE_TRANSITION_BASE_ATTRIBUTE_KEY;
    }
    item.values = generateValues(item);
    return item;
  });

  // For every query added, the query_operator is set default to and so the
  // last query will have an extra query_operator, this would break the api.
  // Setting this to null for all query payload
  payload[payload.length - 1].query_operator = undefined;
  return { payload };
};

export default generatePayload;
